<template>
  <section class="hero-section">
    <b-carousel
      v-if="banners.length"
      controls
      indicators
      background="#ffffff"
      :interval="5000"
      img-width="1600"
      img-height="900"
      class="hero-carousel"
    >
      <b-carousel-slide v-for="banner in banners" :key="banner._id">
        <template #img>
          <div class="hero-slide">
            <img :src="resolveAssetUrl(banner.image)" :alt="banner.title" class="hero-image">
            <div class="hero-overlay"></div>
            <div class="container hero-content">
              <div class="hero-panel glass-card">
                <div class="section-kicker mb-3">Nước sạch - Vận hành bền vững</div>
                <h1 class="hero-title">{{ banner.title }}</h1>
                <p class="hero-copy">{{ banner.description }}</p>
                <router-link :to="getButtonLink(banner.buttonLink)" class="brand-btn brand-btn-primary">
                  {{ banner.buttonText || "Liên hệ ngay" }}
                </router-link>
              </div>
            </div>
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </section>
</template>

<script>
import { resolveAssetUrl } from "../utils/asset";

export default {
  name: "HeroCarousel",
  props: {
    banners: {
      type: Array,
      default: function defaultBanners() {
        return [];
      }
    }
  },
  methods: {
    resolveAssetUrl,
    getButtonLink: function getButtonLink(link) {
      if (/^\/(about|contact|news(?:\/[^/]+)?)\/?$/.test(link || "")) {
        return link;
      }

      return "/contact";
    }
  }
};
</script>

<style scoped>
.hero-section {
  padding: 24px 0 0;
}

.hero-carousel {
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 30px 70px rgba(0, 61, 153, 0.18);
}

.hero-slide {
  position: relative;
  min-height: 620px;
}

.hero-image,
.hero-overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.hero-image {
  object-fit: cover;
}

.hero-overlay {
  background: linear-gradient(90deg, rgba(0, 31, 84, 0.78), rgba(0, 61, 153, 0.14));
}

.hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  min-height: 620px;
  pointer-events: none;
}

.hero-panel {
  max-width: 640px;
  padding: 36px;
  border-radius: 30px;
  pointer-events: auto;
}

.hero-title {
  color: var(--deep-navy);
  font-size: 52px;
  line-height: 1.1;
  font-weight: 800;
  margin-bottom: 18px;
}

.hero-copy {
  color: var(--soft-text);
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 24px;
}

@media (max-width: 991px) {
  .hero-slide,
  .hero-content {
    min-height: 520px;
  }

  .hero-title {
    font-size: 38px;
  }
}
</style>

